<script setup lang="ts">
import type { ConsiderationColor } from '~kui/utils/considerationColor';

import { considerationAreaColor } from '~kui/utils/considerationColor';

interface Props {
  areaLabel: string;
  color?: ConsiderationColor;
  beforeLevel: number;
  beforeProgress: number;
  afterLevel: number;
  afterProgress: number;
  illustration?: string;
  animationsEnabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  color: undefined,
  illustration: undefined,
  animationsEnabled: true,
});

const resolvedColor = computed(() => props.color ?? considerationAreaColor(props.areaLabel));

const displayLevel = ref(props.animationsEnabled ? props.beforeLevel : props.afterLevel);
const displayProgress = ref(props.animationsEnabled ? props.beforeProgress : props.afterProgress);

const timers: ReturnType<typeof setTimeout>[] = [];

onMounted(() => {
  if (!props.animationsEnabled) {
    return;
  }

  const leveledUp = props.afterLevel > props.beforeLevel;

  if (leveledUp) {
    timers.push(setTimeout(() => {
      displayProgress.value = 100;
    }, 400));
    timers.push(setTimeout(() => {
      displayLevel.value = props.afterLevel;
      displayProgress.value = props.afterProgress;
    }, 1100));
  }
  else {
    timers.push(setTimeout(() => {
      displayProgress.value = props.afterProgress;
    }, 400));
  }
});

onUnmounted(() => {
  timers.forEach(clearTimeout);
});
</script>

<template>
  <div class="w-full">
    <KUIUnifiedConsiderationsProgressCard
      class="border"
      :title="areaLabel"
      :level="displayLevel"
      :progress="displayProgress"
      :color="resolvedColor"
      :illustration="illustration"
      :animate-level-up="animationsEnabled"
    />
  </div>
</template>
